const falsy = [undefined, null, NaN, '', 'NA'];

export default falsy;
